import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import MobileSidebar from "./MobileSidebar";
import history from "../../history";
import { logout } from "../../store/actions/authActions";
import { withTranslate } from "react-redux-multilingual";
import { connect } from "react-redux";
import { userType } from "../../utils/userType";

const serviceURL = "https://serviceecom.devsaycheese.com/";
const Navbar = (props) => {
  const [menu, setMenu] = useState(false);
  const [hideNav, sethideNav] = useState(false);
  const [userIs, setUserIs] = useState({ isGiver: false, isSeeker: false });
  const toggleNavbar = () => {
    setMenu(!menu);
  };

  useEffect(() => {
    setUserIs(userType());
    let urlArr = history.location.pathname.split("/");
    // let isGiver = urlArr.includes("giver");
    let personalisation = urlArr.includes("personalisation");
    // let isSeeker = urlArr.includes("seeker");

    if (personalisation && isMobile && !isTablet) {
      sethideNav(true);
    } else {
      sethideNav(false);
    }

    history.listen(() => {
      setUserIs(userType());
      if (personalisation && isMobile && !isTablet) {
        sethideNav(true);
      } else {
        sethideNav(false);
      }
    });
  }, []);

  const classOne = menu ? "show" : "hide";

  const desktop_logout = () => {
    document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/;domain=.devsaycheese.com;"); });
    window.localStorage.clear();
    props.logout();
  }

  

  return hideNav ? (
    ""
  ) : (
    <React.Fragment>
      <nav
        className={`new-navbar navbar navbar-expand-lg navbar-light bg-white ${!isTablet && isMobile ? "flex-row-reverse p-0" : null
          }`}
      >
        <Link
          to={`${process.env.PUBLIC_URL}/`}
          className={`navbar-brand ${!isTablet && isMobile ? "text-center flex-grow-1" : null
            }`}
          id="logo"
        >
          <img
            src={`${process.env.PUBLIC_URL}/assets/images/Logo NEW.png`}
            alt="App landing"
            style={{ maxWidth: "12rem" }}
          />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleNavbar}
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul
            className={`navbar-nav ${!isTablet && isMobile ? "mr-auto " : "ml-auto"
              }`}
          >
            <NavLink to="/" className="nav-item" exact>
              <span className="nav-link">Home</span>
            </NavLink>
            <a
              href={
                userIs.isSeeker === true
                  ? `${serviceURL}?t=${props.token}`
                  : serviceURL
              }
              className="nav-item"
            >
              <span className="nav-link">Services</span>
            </a>

            {props.token &&
              <NavLink
                to={`/myplace/seeker/personalize`}
                className="nav-item"
                onClick={() => window.location.href = "/myplace/seeker/personalize"}
              >
                <span className="nav-link">My Place</span>
              </NavLink>
            }

            <a href={`/networking`} className="nav-item">
              <span className="nav-link">Network</span>
            </a>

            <NavLink
              to={`/myplace/seeker/self-learning`}
              onClick={() => window.location.href = "/myplace/seeker/self-learning"}
              className="nav-item"
            >
              <span className="nav-link">Self Learning</span>
            </NavLink>

            <NavLink
              to={`/whats-new`}
              className="nav-item"
            >
              <span className="nav-link">What's New</span>
            </NavLink>

          </ul>
          <a className="btn custom-btn" href="https://corporate.devsaycheese.com/">
            <i className="fas mr-2 fa-chart-line"></i> Corporate
          </a>
          {!isTablet && isMobile ? null : <span className="line"></span>}
          {!props.token ? (
            <Link
              className="btn custom-btn profile"
              to={`${process.env.PUBLIC_URL}/login`}
            >
              <i className="far fa-user mr-2"></i> Login
            </Link>
          ) : (
            <Link
              className="btn custom-btn profile"
              to={`${process.env.PUBLIC_URL}`}
              onClick={desktop_logout}
            >
              <i className="far fa-user mr-2"></i> Logout
            </Link>
          )}
        </div>
      </nav>
      {isTablet || isMobile ? (
        <MobileSidebar
          menu={classOne}
          toggle={toggleNavbar}
          token={props.token}
          logout={props.logout}
          isSeeker={userIs.isSeeker}
        />
      ) : null}
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    token: state.user.user.token || state.onboard.onboarder.token,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    logout: () => dispatch(logout()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslate(Navbar));
